const mediaItems = [
  {
    title: '某顶流恋情曝光全程时间线梳理',
    duration: '05:28',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20for%20video%20thumbnail%20about%20celebrity%20relationship%20timeline%2C%20timeline%20graphic%20elements%2C%20news%20reporting%20style%2C%20coral%20and%20cream%20gradients%2C%20modern%20flat%20vector%20art&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '综艺选秀黑幕深度调查：知情人士独家专访',
    duration: '12:45',
    views: '98万',
    image: 'https://readdy.ai/api/search-image?query=Teal%20and%20warm%20illustration%20for%20investigative%20video%20thumbnail%2C%20interview%20and%20expose%20theme%2C%20dramatic%20lighting%20effect%2C%20modern%20flat%20vector%20style%2C%20soft%20gradients&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '十大网红翻车名场面合集，笑到肚子疼',
    duration: '08:12',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=Coral%20and%20cream%20illustration%20for%20funny%20compilation%20video%20thumbnail%2C%20playful%20and%20humorous%20mood%2C%20social%20media%20elements%2C%20modern%20flat%20vector%20style%2C%20warm%20gradients&width=800&height=500&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            吃瓜视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选热门吃瓜视频，躺着也能轻松吃瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/60 text-white text-xs rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}